import {
  Component, EventEmitter, HostListener, Input, OnInit,/*  */
  Output
} from "@angular/core";
import { Router } from "@angular/router";

import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";

import { Campaign3Campaign, DistributionCluster3, DistributionListCluster } from "app/views/campaign-3/models/campaign-3.model";
import { ActionStateService } from "app/views/campaign-3/services/actionstate.service";
import { Campaign3TestService } from "app/views/campaign-3/services/campaign3testservice";
import { DistributionList3Service } from "app/views/distribution-list/services/distribution3.service";
import { ChallengeDetail, ChallengeDetailElaborated, ChallengeResponse } from "app/views/challenge/challenge.model";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";


@Component({
  selector: '<app-active-challenges-levels>',
  templateUrl: './challengeinfo-details.component.html',
  styleUrls: ['./challengeinfo-details.component.css']
})
export class ActiveChallengeLevel implements OnInit {

  @Input() actionData;
  @Input() fatherChallenge: ChallengeResponse;
  @Input() challengeDetailList: ChallengeDetail[];
  // @Input() challengeDetailListElaborated: ChallengeDetailElaborated[];
  @Output() refreshCampaignActions = new EventEmitter();
  @Output() refreshClusterList: EventEmitter<any> = new EventEmitter<any>();

  distributionToDelete: any;
  displayDeleteDialog: boolean = false;
  menuCreationActive = false;
  showMenu = false;
  currentOpenedRow;
  actionTypes: Array<{ label: string, value: number, code: string }>;
  campaignList: Array<Campaign3Campaign> = [];
  singleAction: any;
  language: string = "it";
  searchedClusters: DistributionCluster3;

  constructor(public router: Router,
    public testService: Campaign3TestService,
    public srvCalendar: CalendarTranslateService,
    public actionStateService: ActionStateService,
    private distributionService: DistributionList3Service
  ) {
  }

  ngOnInit() {
  }

  onGetActionDescription(actionTypeId: number): string {

    let retValueObject = this.actionTypes.find(x => x.value == actionTypeId);
    let retVal;
    if (retValueObject == undefined) {
      retVal = 'ID not provided';
    } else {
      retVal = retValueObject.label;
    }
    return retVal;
  }



  //per permettere controllo dei menù a tendina
  initMenuActivated() {
    for (let row of this.challengeDetailList) {
      row["menuActivated"] = false;
    }
  }

  toggleMenu(id: number, indexRow: number) {

    // Save the current state of the clicked menu
    let previousValue = this.challengeDetailList[indexRow].menuActivated;
    this.initMenuActivated();
    this.challengeDetailList[indexRow].menuActivated = !previousValue;
    this.currentOpenedRow = id;
    //verificare necessita di questa variabile
    this.showMenu = this.challengeDetailList[indexRow].menuActivated;

  }

  onSearchClusterToAdd() {
    let challengeId: number | null = null;

    if (this.fatherChallenge && this.fatherChallenge.id !== undefined && this.fatherChallenge.id !== null) {
      challengeId = this.fatherChallenge.id;
    }

    if (challengeId !== null) {
      console.log('Invio challengeId:', challengeId);
      this.router.navigate(['/levels-creation'], {
        queryParams: { challengeId: challengeId }
      });
    } else {
      console.error('Nessun challengeId disponibile, navigazione senza parametro');
    }
  }



  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log("nessuna route implementata");
    }
  }

  //per chiudere menù alla pressione fuori dalla ziona indicata
  @HostListener('document:click', ['$event'])
  onClick(event: any) {
    // Check if the click is outside the dropdown menu and the button
    if (!event.target.closest('.dropdown-menu') && !event.target.closest('.btn-details')) {
      // Close all menus
      this.initMenuActivated();
      // Update state
      this.showMenu = false;
      this.currentOpenedRow = null;
    }
  }





  closePopupDelete() {
    this.displayDeleteDialog = false;
  }

  protected readonly JSON = JSON;

  // Funzione per verificare se una distribuzione è scaduta
  checkExpiredChallengeDetail(): string {
    return '';
  }


  // Funzione per eliminare la distribuzione
  onDeleteDistribution(distribution: any, index: number): void {
    this.displayDeleteDialog = true;
    this.distributionToDelete = distribution;

  }

  onEditLevel(level: ChallengeDetailElaborated, index: number): void {
    //this.challengeService.setCurrent(level); // salvi l'entità se vuoi riusarla
    this.router.navigate(['/levels-creation'], {
      queryParams: {
        challengeId: level.challengeId,
        id: level.id
      }
    });
  }





  // Funzione per verificare se il termine della distribuzione è raggiunto
  onCheckEndDistribution(): boolean {
    return false;
  }

  onDefinitiveDelete(distributionToDelete: any): void {
    let distributionId = distributionToDelete.id;
    this.distributionService.deleteClusterHeadFromDistributionList(this.fatherChallenge, distributionId).subscribe(res => {
      console.log(res);
      this.displayDeleteDialog = false;
      //this.refreshClusterList.emit();
    });


  }

  onClickAnnulla_ModalListDistribuzione() {
    this.menuCreationActive = false;
  }

  onDistributionListSelected(event: DistributionListCluster) {
    console.log(event);
    this.menuCreationActive = false;
  }


  closeAddPopupAndRefresh() {
    this.menuCreationActive = false;
    //this.refreshClusterList.emit();
  }



  onEditGifts(level: ChallengeDetailElaborated,): void {
    //this.challengeService.setCurrent(level); // salvi l'entità se vuoi riusarla
    this.router.navigate(['/gifts-creation'], {
      queryParams: {
        challengeId: level.challengeId,
        levelId: level.id
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/challenge/challengeinfo-details/challengeinfo-details.component.ts